import { graphql } from '@/generated/gql';

export const INTERCOM_TOKEN_QUERY = graphql(/* GraphQL */ `
  query IntercomToken {
    tesseract {
      intercom {
        token
      }
    }
  }
`);
